import React from "react";

import { useSettings } from "@/customHooks/useSettings";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";

import { ChefsResults } from "@/components/blocks/global/chefs-results/ChefsResults";
import { SectionTitle } from "@/components/elements/section-title/SectionTitle";
import { Container } from "@mui/material";

export const BestChefsSection = (): JSX.Element => {
  const { t } = useTranslation("chefspage");
  const router = useRouter();

  const searchParams = {
    page_size: 3,
    lang: router.locale
  };
  const { getUsersList } = useSettings();
  const useQueryResult = getUsersList(searchParams);

  return (
    <Container
      sx={{
        display: "flex",
        flexFlow: "column"
      }}>
      <SectionTitle mt={5} mb={2.5} sx={{ textTransform: "none" }}>
        {t("best-chefs.title")}
      </SectionTitle>

      <ChefsResults useQueryResult={useQueryResult} />
    </Container>
  );
};
